import React from "react";
import CatalogItem from "./CatalogItem";

const CatalogList = ({
    loading,
    groupedItems,
    expandedName,
    view,
    onToggleExpand,
    priceBasis,
    rowQuantities,
    onQuantityChange,
    onAddRow,
}) => {
    if (loading) {
        return (
            <div className="pc-list">
                <div className="pc-loading"><div className="pc-spinner" /></div>
            </div>
        );
    }

    return (
        <div className="pc-list">
            {groupedItems.length === 0 && (
                <div className="pc-empty">Ничего не найдено по заданным фильтрам.</div>
            )}
            {groupedItems.map((group) => (
                <CatalogItem
                    key={group.name}
                    group={group}
                    isExpanded={expandedName === group.name}
                    onToggle={() => onToggleExpand(group.name)}
                    priceBasis={priceBasis}
                    rowQuantities={rowQuantities}
                    onQuantityChange={onQuantityChange}
                    onAddRow={onAddRow}
                />
            ))}
        </div>
    );
};

export default CatalogList;
